import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import FormLabel from '../FormLabel/FormLabel';
import Input from '../Input/Input';
import styles from './priceRange.module.scss';

export interface PriceRangeRanges {
  pricemin: number | null;
  pricemax: number | null;
}

interface PriceRangeProps {
  label?: string;
  error?: string | null;
  register: UseFormRegister<PriceRangeRanges>;
  required?: boolean;
}

const PriceRange = ({ label, register, error, required }: PriceRangeProps) => {
  return (
    <>
      {label ? (
        <FormLabel label={label} required={required} error={error} />
      ) : null}
      <div className={styles.priceRangeInputs}>
        <Input
          type="number"
          register={register('pricemin')}
          className="input-number-hide-arrow"
        />
        <span className={styles.priceRangeSeparator}>TO</span>
        <Input
          type="number"
          register={register('pricemax')}
          className="input-number-hide-arrow"
        />
      </div>
    </>
  );
};

export default PriceRange;
